export const fetch_mockups = (state = [], action) => {
	if (action.type == 'RECEIVE_MOCKUPS') {
		console.log('hhh', action.payload)
		return action.payload
	}
  return state;
}

export const is_fetching_mockups = (state = false, action) => {
	switch (action.type) {
		case 'REQUEST_MOCKUPS':
	  		return true;
		case 'RECEIVE_MOCKUPS':
	  		return false;
		default:
	  		return state;
	}
};